module.exports = __webpack_public_path__ + "images/home_icon_card_add_n@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home_icon_card_add_n@2x.png
// module id = 854
// module chunks = 121